module.exports = __webpack_public_path__ + "static/media/receta-16.4e293b1f.png";